
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import DrinksIt from './drinksIt';

const SHARED_CATEGORIES = ['postres', 'licor', 'coffe', 'drinks', 'bebidas'];

const stripLtPrefix = (name) =>
    (name || '').replace(/^LT\s*-\s*/i, '').trim();

function Index({dishs, setShowListProduct, goHome, homeMode = 2}) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
    const [menus, setMenus] = useState(menusCurrent);


    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showDrinksIt, setShowDrinksIt] = useState(false);

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);


    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {
            
            if (item.id === 943) {
                setBeverages(item);
            }
        });
      }, [menusData]);
    
const GoBeverages = () => {
          if (homeMode === 2) {
                            setShowDrinksIt(true)
                        } else {
                            setShowDrinks(true);
                        }
    }


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const ItemNoImage = ({ data }) => (
        <div style={{
            width: '48%',
            margin: '0px 0px 15px',
            textAlign: 'left',
            boxSizing: 'border-box',
            position: 'relative',
        }}>
            <h3 style={
                { color: '#fff', textTransform: 'uppercase', fontSize: 24, margin: '0 0 4px', textAlign: 'left', fontFamily: 'Noodle' }
                }>
                {langEng ? data.name : translate(i18n.language, data.language, data.name)}
            </h3>

            <p style={{ fontFamily: "Noodle", fontSize: 18, color: '#fff', textAlign: 'left', margin: 0, textTransform: 'uppercase', fontWeight: '500'}}>
                {langEng ?
                        `${data.regular_decription.replace(/\\n/g,'\n')}`
                    :
                        `${translateMenu(
                            i18n.language,
                            data.language,
                            data.regular_decription,
                            'regular_decription'
                        )}`
                }
            </p>
        </div>
    );

    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-h-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);

                }
            });
        }, []);

        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: '#f4d3a9', marginBottom: 30, textDecoration: 'none',
                width: '48%',
                maxHeight: 450,
                margin: '0px 0px 15px',
                textAlign: 'left',
               
                paddingBottom: 20,
              
                boxSizing: 'border-box',
                position: 'relative',
                borderRadius: 15,
            }}>
                <img src={image}  style={{width: '100%', height: 220, objectFit: 'cover',    borderRadius: 10,}}/>
                <h3 style={
                    {  color: '#000', textTransform: 'uppercase', fontSize: 24, margin: '10px 0 0', textAlign: 'left',marginLeft:20, fontFamily: 'Noodle' }
                    }>
                    
                    {/* {data.name} */}
                    {langEng ? data.name : translate(i18n.language, data.language, data.name)}
                
                </h3>
                
                <div style={{width: '100%', margin: '0 auto'}}>
                    <p
                       
                        style={{ fontFamily: "Noodle", fontSize: 18, color: '#000', textAlign: 'left', margin: 0, marginLeft:20,textTransform: 'uppercase', fontWeight: '500'}}>

                        {/* {`${data.regular_decription.replace(/\\n/g,'\n')}`} */}
                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
            </div>
        );
    }
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
               GoBeverages()
        }} showCocktails={ setShowCocktails}  showLamp={ false}   showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div style={{
                   // backgroundImage: `url(${require('./assets/barra.png')})`,
                    background: '#d8b887',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '93%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 5
                }}>
                    {menusData.map((item, key) => {
                             if (![943, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                const isLT = item.name.startsWith('LT');
                                const isShared = SHARED_CATEGORIES.includes(item.name.toLowerCase().trim());
                                if (homeMode === 1 && !isLT && !isShared) return null;
                                if (homeMode === 2 && isLT) return null;
                                return <div key={key} style={{
                                    background: '#f9e6c8',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '2px 28px',
                                    borderRadius: 5,
                                    minWidth: 'fit-content'
                            }}
                                    onClick={() => { 
                                    if(item.id === 867) {
                                       // setshowHotDrinks(true)
                                    } else {    
                                        setMenus(item.menus)
                                    }
                                }}
                                >
                                    <p className='shor-text' style={{ color: '#000', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase',  }}>
{/* {item.name} */}
                                        
                                    {stripLtPrefix(
                                    langEng
                                        ? item.name
                                        : translateMenu(
                                            i18n.language,
                                            item.language,
                                            item.name,
                                            'name'
                                        )
                                    )}
                                    </p>

                            </div>
                            }
                            
                        })}
                </div>

             
                {menus.length > 0 && menus[0].categorie_id === 950 && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/pastasen.png' : './assets/pastases.png'
                        )} style={{width: '100%', height: 123, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}

                {menus.length > 0 && menus[0].categorie_id === 929 && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/saladsen.png' : './assets/saladses.png'
                        )} style={{width: '100%', height: 123, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}

                {menus.length > 0 && menus[0].categorie_id === 934 && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/burgeren.png' : './assets/burgeres.png'
                        )} style={{width: '100%', height: 123, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}

                {menus.length > 0 && (menus[0].categorie_id === 936 || menus[0].categorie_id === 938 || menus[0].categorie_id === 937) && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/chikenes.png' : './assets/chikenen.png'
                        )} style={{width: '100%', height: 123, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}
                {menus.length > 0 && menus[0].categorie_id === 940 && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/pizzaes.png' : './assets/pizzaes.png'
                        )} style={{width: '100%', height: 90, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}

                {menus.length > 0 && menus[0].categorie_id === 956 && (
                    <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                        <img src={require(
                            langEng ? './assets/fuertes.png' : './assets/fuertes.png'
                        )} style={{width: '100%', height: 90, objectFit: 'contain', borderRadius: 15}} />
                    </div>
                )}

                
                <div >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        paddingInline: 20,
                        marginTop: 20
                        
                       
                    }}>
                       
                         <div className="hide-scrollbar" style={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            gap: '4%',
                            padding: '0px 0px 100px 0px',
                            maxHeight: menus.length > 0 && menus[0].categorie_id === 950 ? 500 :
                                menus.length > 0 && menus[0].categorie_id === 929 ? 500 :
                                    menus.length > 0 && menus[0].categorie_id === 934 ? 500 :
                                        menus.length > 0 && (menus[0].categorie_id === 936 || menus[0].categorie_id === 938 || menus[0].categorie_id === 937) ? 500 :
                                            menus.length > 0 && menus[0].categorie_id === 940 ? 500 :
                                        menus.length > 0 && menus[0].categorie_id === 956 ? 500 :
                                    600,
                            overflowY: 'scroll',
                            marginTop: 15,
                            
                        }}>
                            {menus.filter((item) => !item.no_image).map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                            {menus.filter((item) => item.no_image).map((item, key) => (
                                <ItemNoImage data={ item }  key={`no-image-${key}`} />
                            ))}
                    </div>   
                    </div>
                   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}
                {showDrinksIt && <DrinksIt setShowHappy={setShowDrinksIt} />}
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;